<script lang="ts">
    import type { EnergyLabel } from '@shared/types/types.ts';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';

    const wiring = injectWiring(['trackingService']);

    let label = $state<EnergyLabel | null>(null);
    let title = $derived(label ? `${label.component} Energieeffizienzklasse` : 'Energieeffizienzklasse');

    function handleSheetAfterClose() {
        label = null;
    }

    function isEnergyLabel(data: unknown): data is EnergyLabel {
        return (
            data !== null &&
            typeof data === 'object' &&
            'component' in data &&
            'labelUri' in data &&
            'datasheetUri' in data
        );
    }

    function handleSheetBeforeOpen(event: CustomEvent) {
        const extraData = event.detail.extraData;
        label = isEnergyLabel(extraData) ? extraData : null;
    }
</script>

<oc-sheet-v1
    id="reptile-eek-sheet"
    onoc-sheet-after-close={handleSheetAfterClose}
    onoc-sheet-before-open={handleSheetBeforeOpen}
    onoc-sheet-open={() => wiring.trackingService?.trackListLayer('energyclass')}
>
    <h3 slot="headline">{title}</h3>
    <div class="energy-sheet">
        {#if label?.labelUri}
            <img alt={title} src={label.labelUri} loading="lazy" />
        {/if}
        {#if label?.datasheetUri}
            <oc-button-v1 size={'100'} variant="secondary">
                <a
                    href={label.datasheetUri}
                    target="_blank"
                    class="oc-copy-125"
                    onclick={() => wiring.trackingService?.trackInteraction('datasheet_layer')}
                    >Produktdatenblatt (PDF)</a
                >
            </oc-button-v1>
        {/if}
    </div>
</oc-sheet-v1>

<style lang="scss">
    .reptile-energy-sheet {
        img {
            max-width: 100%;
        }
    }
</style>
